import { useStyletron } from "baseui";
import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useState } from "react";

export const SuccessIndicator = (props: { autoHideDuration?: number; $size?: string }) => {
  const [show, setShow] = useState(true);
  const [css, $theme] = useStyletron();
  const size = props.$size || $theme.sizing.scale1000;

  useEffect(() => {
    if (props.autoHideDuration) {
      const timeout = setTimeout(() => {
        setShow(false);
      }, props.autoHideDuration);

      return () => clearTimeout(timeout);
    }
  }, [props.autoHideDuration]);

  return (
    <AnimatePresence>
      {show && (
        <motion.svg
          data-testid="success-indicator"
          viewBox="0 0 50 50"
          initial={{ opacity: 1, scale: 0.8 }}
          animate={{ scale: 1, transition: { staggerChildren: 0.5 } }}
          exit={{ opacity: [1, 0], scale: [1, 0.9], transition: { duration: 1.5, times: [0.8, 1] } }}
          className={css({
            display: "inline-block",
            height: size,
            width: size,
          })}
        >
          <motion.path
            fill="none"
            strokeWidth="5"
            stroke={$theme.colors.positive400}
            strokeDasharray="0 1"
            d="M 0, 20 a 20, 20 0 1,0 40,0 a 20, 20 0 1,0 -40,0"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1, transition: { duration: 0.7, ease: "easeInOut" } }}
            style={{
              rotate: 90,
              translateX: 5,
              translateY: 5,
              scaleX: -1, // Reverse direction of line animation
            }}
          />
          <motion.path
            fill="none"
            strokeWidth="5"
            stroke={$theme.colors.positive400}
            d="M14,26 L 22,33 L 35,16"
            strokeDasharray="0 1"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1, transition: { duration: 0.5 } }}
          />
        </motion.svg>
      )}
    </AnimatePresence>
  );
};
